/* eslint-disable eqeqeq */
import recieve from "../assets/video/recieve_msg.mp3";
import send from "../assets/video/send_msg.mp3";

export default class Sound {
  static send() {
    let a = new Audio(send);
    try {
      var chrome =
        window.navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
      if (chrome) {
        a.play();
      }
    } catch (e) {
      console.error(e);
    }
  }

  static receive() {
    let a = new Audio(recieve);
    try {
      var chrome =
        window.navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
      if (chrome) {
        a.play();
      }
    } catch (e) {
      console.error(e);
    }
  }
}
